module.exports = __webpack_public_path__ + "img/gb-sct.071d47b3.svg";